import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { DeviceSetupTaskDto } from '../../dto/DeviceSetupTaskDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApiVersion } from '../../utils/utils';
import { getApi } from '../getApi';

export const apiUpdateSetup = async (dto?: DeviceSetupTaskDto) => {
  const apiVersion = getApiVersion();
  const params: IApiParams = {
    url: `/setup/updateSetup${apiVersion}.php`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
